import { useEffect } from 'react';

const useMetaTags = (config) => {
  useEffect(() => {
    // Set title
    if (config.title) {
      document.title = config.title;
    }

    // Set or update meta tags
    const setMetaTag = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`) ||
                    document.querySelector(`meta[property="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(name.startsWith('og:') ? 'property' : 'name', name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Standard Meta Tags
    if (config.description) {
      setMetaTag('description', config.description);
    }

    if (config.keywords) {
      setMetaTag('keywords', config.keywords);
    }

    // Open Graph Tags
    if (config.ogTitle) {
      setMetaTag('og:title', config.ogTitle);
    }

    if (config.ogDescription) {
      setMetaTag('og:description', config.ogDescription);
    }

    if (config.ogImage) {
      setMetaTag('og:image', config.ogImage);
    }

    if (config.ogUrl) {
      setMetaTag('og:url', config.ogUrl);
    }

    if (config.ogType) {
      setMetaTag('og:type', config.ogType);
    }

    // Twitter Tags
    if (config.twitterCard) {
      setMetaTag('twitter:card', config.twitterCard);
    }

    if (config.twitterTitle) {
      setMetaTag('twitter:title', config.twitterTitle);
    }

    if (config.twitterDescription) {
      setMetaTag('twitter:description', config.twitterDescription);
    }

    if (config.twitterImage) {
      setMetaTag('twitter:image', config.twitterImage);
    }

    // Canonical URL
    if (config.canonical) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = config.canonical;
    }

    // Viewport (usually set in HTML, but just in case)
    setMetaTag('viewport', 'width=device-width, initial-scale=1.0');

    // Return cleanup function
    return () => {
      // Optional: You could remove meta tags here if needed
    };
  }, [config]);
};

export default useMetaTags;
